<template>
  <div class="yunxiao teachaer clue-detail">
    <div class="main">
      <div class="infos-nave other-infos">
        <div 
          v-if="infos.studentId"  
          class="student-nav" 
          @click="$router.push(`/baseStudentInfos?id=${infos.studentId}`)">
          <div class="photo-nav" v-if="!infos.studentDto || !infos.studentDto.photo || !infos.studentDto.url">
            {{ infos.studentDto && infos.studentDto.name && infos.studentDto.name.substr(-2) }}
          </div>
          <img class="photo-nav" v-else :src="infos.studentDto.photo.url" />
          <div class="infos-column">
            <span class="name">{{infos.studentDto.name}}</span>
          </div>
          <van-icon name="arrow" size="var(--fs-lg)"></van-icon>
        </div>
        <div class="content-nav">
          <div class="line">
            <div class="content">
              {{infos.content || '-'}}
            </div>
            <span 
              class="status-tag" 
              :class="{
                red: infos.status === 3 || infos.status === 4,
                green: infos.status === 2
              }">
              {{statusDesc[infos.status]}}
            </span>
          </div>
          <div class="line">
            <van-rate
              v-model="infos.level"
              icon="like"
              void-icon="like-o"
              :size="12"
              color="var(--c-rate)"
              readonly
            />
            <div class="bind-order-status" v-if="infos.orderId" @click="$router.push(`orderDetail/${infos.orderId}/0/1`)">
              <van-icon class-prefix="vxs-icon" name="icon-"></van-icon>
              已关联订单
              <van-icon name="arrow"></van-icon>
            </div>
          </div>
        </div>


        <div class="line">
          <div class="label">手机号码</div>
          <div class="content" style="user-select:text;">
            <span v-if="infos.studentId">
              {{this.getRelationName(infos.contactsPhone)}}
            </span>
            <!-- 
              这里只需要脱敏学员联系人手机号，不需要脱敏待确认意向联系电话
              通过infos.studentId判断是否为已确认意思，通过脱敏位数参数实现意向联系电话不脱敏
              -->
            <a :href="app.teacher.user.disableDialNumber && infos.studentId? 'javascript:void(0);' : ('tel:'+infos.contactsPhone)">

              {{infos.contactsPhone | disableDialNumber(infos.studentId?3:7)}}
            </a>
          </div>
        </div>
        <div class="line">
          <div class="label">跟进人</div>
          <div class="content">
            {{infos.followTeacherName||'暂无'}}
            <span 
              class="a" 
              v-if="infos.status!==3 && app.permission.op('distribute_intention_clue')" 
              @click="choiceTeacher">
              {{!infos.followTeacherName ? '分配':'修改'}}
            </span>
          </div>
        </div>
        <div class="line">
          <div class="label">介绍人</div>
          <div class="content">
            {{infos.introducerName||'-'}}
          </div>
        </div>
        <div class="line">
          <div class="label">报名校区</div>
          <div class="content">
            {{infos.campusName||'-'}}
          </div>
        </div>
        <div class="line" :style="infos.studentId ? {marginBottom: 'calc(var(--gap)*12)'}:{}">
          <div class="label">备注</div>
          <div class="content">
            {{infos.remark||'-'}}
          </div>
        </div>
        <transition name="flip-list" >
          <div class="fold-nav" v-show="foldInfos && !infos.studentId">

            <div class="line">
              <div class="label">姓名</div>
              <div class="content">
                {{infos.name}}
              </div>
            </div>

            <div class="line">
              <div class="label">性别</div>
              <div class="content">
                {{['女','男', '未知'][infos.sex]}}
              </div>
            </div>
            <div class="line" >
              <div class="label">出生日期</div>
              <div class="content" v-if="infos.birthday">
                {{infos.birthday | formatDatetime('yyyy-MM-dd')}}
              </div>
              <div class="content" v-else>
                -
              </div>
            </div>

            <div class="line">
              <div class="label">微信号</div>
              <div class="content">
                {{infos.contactsWechatCode||'-'}}
              </div>
            </div>
            <div 
              class="line"         
              v-for="customField of showCustomFieldList" 
              :key="customField.customFieldId">
              <div class="label">{{customField.fieldName}}<span class="zi-tag" v-if="!customField.fieldCode">自定义</span></div>
              <div class="content">
                {{customFieldGetValue(customField)}}
              </div>
            </div>
            <div class="line">
              <div class="label">创建人</div>
              <div class="content">
                {{infos.createTeacherName||'暂无'}}
              </div>
            </div>
            <div class="line">
              <div class="label">创建时间</div>
              <div class="content">
                {{infos.createTime| formatDatetime('yyyy-MM-dd hh:mm')}}
              </div>
            </div>
          </div>
        </transition>

        <div 
          class="fold-btns-line" 
          v-if="!infos.studentId"
          :class="{show: foldInfos}" @click="foldInfos=!foldInfos">
          {{foldInfos?'收起':'展开'}}
          <i class="van-icon van-icon-arrow-down"></i>
        </div>



      </div>
      <div class="infos-nave other-infos">
        <div class="title">
          <div class="left">
            动态记录
          </div>

        </div>     
        <van-empty
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="没有记录"
          v-if="!log.length"
          image-size="128"
        />     
        <mixied-communicate v-else :logs="log" :loading="logLoading"  :clueInfos="infos" :isRecycleBin="!!infos.recovery"  />
      </div>
    </div>
    <div class="operation-nav van-hairline--top" v-if="infos.status === 0 ">
      <div class="btn" @click="onSelectClueMark({id:1})" v-if="!this.infos.studentId">
        <van-icon class-prefix="vxs-icon" name="youxiao"></van-icon>
        <div>转为意向学员</div>
      </div>
      <div class="btn" @click="$router.push('/clueAddCommunication?clueId=' + infos.id)">
        <van-icon name="add-o" />
        <div>新增记录</div>
      </div>
      <div class="btn"  
        @click="$router.push('/addClue?id=' + clueId)" 
        v-if="infos.followStatusCode !== 'OFFICIALLY' && infos.status!==3 && app.permission.op('update_intention_clue')">
        <van-icon name="edit" />
        <div>编辑</div>
      </div>
      <div class="btn" @click="clueAbandonFollow">
        <van-icon class-prefix="vxs-icon" name="huishouzhan"></van-icon>
        <div>移入回收站</div>
      </div>
    </div>
    <div 
      class="operation-nav van-hairline--top" 
      v-if="(infos.status === 3  || infos.status === 4) && app.permission.op('delete_intention_clue || reback_intention_clue')">
      <div class="btn" @click="resetClues" v-if="app.permission.op('reback_intention_clue')">
        <van-icon class-prefix="vxs-icon" name="huifu"></van-icon>
        <div>恢复</div>
      </div>
      <div class="btn" v-if="infos.status !== 3" @click="$router.push('/clueAddCommunication?clueId=' + infos.id)">
        <van-icon name="add-o" />
        <div>新增记录</div>
      </div>
      <div class="btn"  
        @click="$router.push('/addClue?id=' + clueId)" 
        v-if="infos.followStatusCode !== 'OFFICIALLY' && infos.status!==3 && app.permission.op('update_intention_clue')">
        <van-icon name="edit" />
        <div>编辑</div>
      </div>
      <div class="btn" @click="toDeleteClues" v-if="app.permission.op('delete_intention_clue')">
        <van-icon class-prefix="vxs-icon" name="shanchu"></van-icon>
        <div>彻底删除</div>
      </div>
    </div>
    <div class="operation-nav van-hairline--top" v-if="infos.status === 1 ">
      <div 
        class="btn"  
        v-if="app.permission.op('add_audition')"
        @click="$router.push(`/auditionAdd?name=${infos.studentDto.name}&id=${infos.studentId}&cludId=${clueId}`)">
        <van-icon class-prefix="vxs-icon" name="shiting"></van-icon>
        <div>安排试听</div>
      </div>

      <div class="btn"  @click="toSf" v-if="app.permission.op('charge')">
        <van-icon class-prefix="vxs-icon" name="shoufei"></van-icon>
        <div>收费</div>
      </div>
      <div class="btn" @click="$router.push('/clueAddCommunication?clueId=' + infos.id)">
        <van-icon name="add-o" />
        <div>新增记录</div>
      </div>
      <div class="btn"  
        @click="$router.push('/addClue?id=' + clueId)" 
        v-if="infos.followStatusCode !== 'OFFICIALLY' && infos.status!==3 && app.permission.op('update_intention_clue')">
        <van-icon name="edit" />
        <div>编辑</div>
      </div>
      <div class="btn" @click="showClueMark=true">
        <van-icon class-prefix="vxs-icon" name="gengduo" ></van-icon>
        <div>更多操作</div>
      </div>
    </div>
    <van-action-sheet
      v-model="showClueMark"
      :actions="clueMarkActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="showClueMark = false"
      @select="onSelectClueMark"
    />
    <van-dialog 
      v-model="delAllConfigDialog" 
      title="提示" 
      :show-confirm-button="false">
      <div class="del-all-config-content">        
        有其他相同手机号的待清洗意向，是否一并移入回收站
      </div>
        <van-button
          block
          type="default"
          @click="doClueAbandonFollow(2)"
          size="large"
          style="color: var(--c3)"
          class="van-dialog__confirm van-hairline--top"
          >
          全部移入回收站
        </van-button>
        <van-button
          block
          type="default"
          @click="doClueAbandonFollow(1)"
          size="large"
          style="color: var(--c3)"
          class="van-dialog__confirm van-hairline--top"
          >
          仅此意向移入回收站
        </van-button>
        <van-button
          block
          type="default"
          @click="delAllConfigDialog = false"
          size="large"
          style="color: var(--g8)"
          class="van-dialog__confirm van-hairline--top"
          >
          取消
        </van-button>
    </van-dialog>
  </div>
</template>
<script>
import mixiedCommunicate from './children/mixied-communicate.vue';

export default {
  name: 'clueDetails',
  components: {
    mixiedCommunicate
  },
  inject: ['studentsStatusDict'],
  data () {
    return {
      pageTitle: '意向详情',
      clueId: this.$vxRoute.query.id,
      infos: {
        studentDto: {}
      },
      statusDesc: ['待确认','跟进中','已转化','已回收','转化失败'],

      showClueMark: false,
      logLoading: false,
      log: [],
      delAllConfigDialog: false,
      clueMarkActions: [
        // {
        //   name: "有效意向",
        //   id: 1,
        // },
        {
          name: "标记转化失败",
          id: 0,
        },
      ],
      foldInfos: false,
    }
  },
  computed: {
    showCustomFieldList () {
      let {customFieldList = []} = this.infos || {};
      return customFieldList.filter(({display,businessType})=>businessType === "STUDENT_INTENTION" && display>0)
    }
  },
  methods: {
    getDetials () {
      let {clueId} = this;
      return this.$api.clueDetails({clueId})
        .then(res=>{
          this.infos = {};
          if (res.code === 200) {
            this.infos = res.data;
            return false;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          console.log(err)
        })
    },
    getfollowStatus() {
      this.$api.getFollowStatusList().then((res) => {
        if (res.code === 200) {
          this.followStatus = res.data;
        }
      });
    },
    getClueCommunicateList () {
      this.logLoading = true;
      this.$api.clueCommunicateList({intentionClueId: this.clueId}).then((res) => {
        this.logLoading = false;
        if (res.code === 200) {
          this.log = res.data;
        }
      })
      .catch(err=> {
        this.logLoading = false;
        if (!err.msg) {
          console.log(err)
        }
      });
    },
    async loadingAllDatas () {
      let promise = Promise.all([this.getDetials(), this.getClueCommunicateList()]);
      this.showLoading();
      try{
        await promise;
      }catch(err){
        this.$toast.clear();
      }
      this.$toast.clear();
    },
    customFieldGetValue (field) {
      if (field.fieldDataType===4) {
        let { selectItemList = [], value } = field;
        if (!selectItemList || value === null) return '-';
        let sLen = selectItemList.length;
        for (let i =0;i<sLen;i++) {
          let item = selectItemList[i]
          if (item.id == value || item.itemCode == value) {
            return item.itemName || '-'
          } 
        }
        return '-';
      } else if (field.fieldDataType === 5) {
        let { selectItemList = [], valueList } = field;
        if (!valueList || valueList.length == 0) return '-';
        return valueList.map(val=>(selectItemList.find(sel=>sel.id == val) || {}).itemName).join('，')
      }

      return field.value || '-';

    },
    async choiceTeacher() {
      let res = await app.x3.side.xsTeacher({
        id: this.infos.followTeacherId,
        params: {
          campusIds: this.infos.campusId ? [this.infos.campusId]:[],
          statusList: [1],
        }
      });
      this.infos.followTeacherId = res ? res.id : "";
      this.infos.followTeacherName = res ? res.name : "";
      this.showLoading();
      this.$api.putClue({...this.infos,phone: this.infos.contactsPhone})
        .then(res=>{
          if (res.code === 200) {           
            this.$toast.success('分配成功');
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{          
          if (!err.code) {
            console.log(err)
            this.$toast.clear();
          }
        })
    },
    // 意向移入回收站
    clueAbandonFollow () {
      this.$dialog
        .confirm({
          title: "提示",
          messageAlign: 'left',
          message: '意向移入回收站后，可在【意向回收】内恢复或删除',
          confirmButtonText: "确认移入回收站",
          cancelButtonText: "取消",
          confirmButtonColor: "var(--c3)",
        })
        .then(() => {
          this.doClueAbandonFollow();
        })
        .catch(() => {});

    },
    doClueAbandonFollow (samePhoneBatchHandleType=0) {
      let { clueId } = this;
      this.$api.clueAbandonFollow({clueId,samePhoneBatchHandleType})
        .then(res=>{
          if (res.code === 200) {
            this.$toast.success('操作成功');
            app.vue.$emit('operation-clue-success');
            this.$router.back();
            return false;
          }
          if (res.code === 810000014) {
            this.delAllConfigDialog = true;
            return false;
          }
          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{
          if (!err.msg) {
            console.log(err)
            this.$toast.clear();
          }
        })
    },
    resetClues() {
      this.$dialog
        .confirm({
          title: "提示",
          messageAlign: 'left',
          message: this.infos.status === 4 ? 
                  `${this.infos.name}将被恢复至跟进中状态，是否恢复意向？` 
                  : `${this.infos.name}将被恢复至“待清洗意向”，可进行再次分配，是否恢复意向？`,
          confirmButtonText: "恢复意向",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.toResetClues();
        })
        .catch(() => {});
    },
    toResetClues () {
      let { clueId } = this;
      this.showLoading();
      this.$api.clueResumeClue({clueIds: [clueId], needCheck: true})
        .then(res=> {
          if (res.code === 200) {    
            this.refreshAllDatas();
            this.$toast.clear();
            app.vue.$emit('resume-clues-success');
            return false;
          }
          if (res.code === 810000005) {      
            let len = res.data.intentionClueDos.length;
            let name = res.data.intentionClueDos[0].name;
            app.http.tipErr( `未找到${len === 1 ? name : `${name}等${len}条意向`},请重新选择需要分配的意向`);
            return false;
          }

          if (res.code > 60000) {
            this.$toast.fail(res.msg || '网络异常，请稍后重试');
          }
        })
        .catch(err=>{          
          if (!err.code) {
            this.$toast.clear();
          }
        })
    },
    toDeleteClues () {
      let { clueId, infos } = this;
      this.$dialog
        .confirm({
          className: 'clue-recycle-dialog',
          title: "提示",
          messageAlign: 'left',
          message: `${infos.name}将被彻底删除，意向相关的信息都不会保留，是否确认删除？`,
          confirmButtonText: "确认删除",
          cancelButtonText: "取消",
          confirmButtonColor: "var(--c3)",
        })
        .then(() => {
          this.showLoading();
          this.$api.deleteClues({clueIds: [clueId], needCheck: true})
            .then(res=> {
              if (res.code === 200) {                     
                this.$toast.success('操作成功');
                app.vue.$emit('delete-clues-success');
                this.$router.back();
                return false;
              }
              if (res.code === 810000005) {        
                let len = res.data.intentionClueDos.length;
                let name = res.data.intentionClueDos[0].name
                let nameInfos = `未找到${len === 1 ? name : `${name}等${len}条意向`},请重新选择需要分配的意向`
                this.$toast(nameInfos)
                return false;
              }

              if (res.code > 60000) {
                this.$toast.fail(res.msg || '网络异常，请稍后重试');
              }
            })
            .catch(err=>{          
              if (!err.code) {
                this.$toast.clear();
              }
            })
        })
        .catch(() => {});

    },
    async onSelectClueMark(val) {
      if (val.id === 1) {
        if (!this.infos.studentId) {
          this.p = 'change'
          this.$router.push('/clueChargeToFormal?id=' + this.clueId);
        }
        
        return false;
      }
      let conInvalidClue = true;
              
      if (this.infos.orderId) {
        try {
          conInvalidClue = await this.$dialog.confirm({
            title: '提示',
            message: `该意向已关联有效订单, 请先取消关联此意向`,
            confirmButtonText: "查看订单",
            cancelButtonText: "取消",
          })
          .then(() => {
            this.$router.push(`orderDetail/${this.infos.orderId}/0/1`)
          })
          .catch((err) => {
            console.log(err);
          });
        } catch(err) {
          conInvalidClue = false;
          console.log(err)
        }
      }
      //意向标记选择
      if (conInvalidClue){ 
        this.showLoading();
        this.$api
          .invalidClue({
            clueId: this.clueId,
          })
          .then((res) => {
            if (res.code === 200) {
              this.refreshAllDatas();
              this.$toast.success('操作成功');
              app.vue.$emit('change-clue-success');
            } else {
              this.$toast.fail(res.msg);
            }
          });
      }
    },
    // 标记转化
    markSuccess () {   
      this.$dialog
        .confirm({
          title: "提示",
          message: '是否将学员该意向标记转化，转化后意向状态不可再变更',
          confirmButtonText: "确认转化",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.showLoading();
          this.$api
            .clueBecomeConverted({
              clueId: this.clueId,
            })
            .then((res) => {
              if (res.code === 200) {
                this.refreshAllDatas();
                this.$toast.success('操作成功');
                app.vue.$emit('change-clue-success');
              } else {
                this.$toast.fail(res.msg);
              }
            })
            .catch(err=>{          
              if (!err.code) {
                this.$toast.clear();
              }
            })
        })
        .catch(() => {});   

    },

    refreshAllDatas () {
      this.getDetials();
      this.getClueCommunicateList();
    },
    toSf () {
      let {id, studentId, orderId} = this.infos;
      if (!orderId) {
        this.$router.push(`/sf1?studentId=${studentId}&clueId=${id}`);
      } else {
        this.$dialog.confirm({
          title: '提示',
          message: `该意向已关联有效订单, 请先取消关联此意向`,
          confirmButtonText: "查看订单",
          cancelButtonText: "取消",
        })
        .then(() => {
          this.$router.push(`orderDetail/${this.infos.orderId}/0/1`)
        })
        .catch((err) => {
          console.log(err);
        });
      }
      
    },
    getRelationName (phone) {
      let {studentParentRelation = []} = this.infos.studentDto;
      for (let i=0, len = studentParentRelation.length;i<len;i++) {
        if (studentParentRelation[i].parentPhone === phone) {
          return studentParentRelation[i].relation;
        }
      }
      return '';
    }
  },
  created (){
    this.getfollowStatus();
    this.loadingAllDatas();    
    this.$onBus('add-clue-communicate-success', this.refreshAllDatas);
    this.$onBus('add-clue-audition-success', this.refreshAllDatas);
    this.$onBus('refresh-communicate-list', this.getClueCommunicateList);
    this.$onBus('change-clue-success', ()=>{
      this.refreshAllDatas();
      app.vue.$emit('refresh-student-clues-record-list')
    });
    this.$onBus('edit-clue-success', ()=>{
      this.getDetials()
      app.vue.$emit('refresh-student-clues-record-list')
    });
    this.$onBus("clue-repeate-bind-success", ()=>{
      this.getDetials()
      app.vue.$emit('refresh-student-clues-record-list')
    });;
    this.$onBus("studentInfoRefresh", ()=>{
      this.getDetials()
      app.vue.$emit('refresh-student-clues-record-list')
    });;
  }
      
}
</script>
<style lang="scss" scoped>

.yunxiao.teachaer.clue-detail{
  display: flex;
  flex-direction: column;
  .main{
    flex:1;
    overflow-y: auto;
  }
  .student-nav{
    display: flex;
    margin: calc(var(--gap) * 12) 0 calc(var(--gap) * 8);
    padding: calc(var(--gap) * 5) 0;
    background-color: var(--white);
    align-items: center;
    .photo-nav {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      font-size: var(--fs-lg);
      line-height: var(--lh-lg);
      color: var(--white);
      background-color: var(--c1);
      border-radius: 50%;
      border: unset;
      outline: unset;
      margin-right: calc(var(--gap) * 8);
    }

    .infos-column{
      flex: 1;
      >span.name{
        font-size:var(--fs-lg);
        line-height:var(--lh-lg);

      }
    }
    >i{
      color: var(--g6);
    }
  }
  .status-tag{
    padding: 0 calc(var(--gap) * 4);
    color: var(--c1);
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    font-weight: normal;

    &.red{
      color: var(--c3);
      border-color: var(--c3);
    }
    &.green{
      color: var(--c2);
      border-color: var(--c2);
    }
  }
  .infos-nave{
    margin: 0 0 calc(var(--gap) * 12) ;
    padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 16);
    background-color: var(--white);
    overflow: hidden;

    .content-nav{
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 10);
      margin: calc(var(--gap) * 12) 0 calc(var(--gap) * 8);
      border-radius: var(--radius-sm);
      background-color: var(--g1);
      >.line{
        min-height: unset;
        display: flex;
        justify-content: space-between;
        .content{
          font-size:var(--fs-lg);
          line-height:var(--lh-lg);
          text-align: left;
        }
        &:not(:last-child){
          margin-bottom: calc(var(--gap) * 8);
        }
      }
      .bind-order-status{
        display: flex;
        height: calc(var(--gap) * 16);
        font-size: var(--fs-xs);
        line-height:var(--lh-xs);
        background: var(--c1);
        border-radius: var(--radius-sm);
        align-items: center;
        color: var(--white);
        i:first-child{
          font-size:var(--fs-sm);
          line-height:var(--fs-sm);
          width:var(--fs-sm);
          margin:0 calc(var(--gap) * 2);
          color: var(--c1);
          background: var(--white);
          border-radius: 50%;
          text-align: center;
        }
        >i{
          margin: 0 calc(var(--gap) * 2);
        }
      }
    }
    >.title{
      display: flex;
      min-height: calc(var(--w) * 48);
      font-size:var(--fs-lg);
      line-height:var(--lh-lg);
      font-weight: var(--bold);
      justify-content: space-between;
      align-items: center;
      .left{
        flex: 1;
      }
      .right{
        flex-shrink: 0;
        white-space: nowrap;

        .icon {
          font-size: calc(var(--w)*24);
          &:last-child{
            margin-left: calc(var(--gap) * 24);
          }
        }
      }

      ::v-deep .van-rate>div{
        padding: 0;
        margin-right: calc(var(--gap) * 12);
      }
    }
    >.title.sub-title{
      min-height: auto;
      padding: 0 0 calc(var(--gap) * 16);
    }
    .line{
      display: flex;
      min-height: calc(var(--w) * 28);
      margin: calc(var(--gap) * 6) 0;
      align-items: center;
      .label{
        width: calc(var(--w) * 160);
        flex-shrink: 0;
        color: var(--g6);
      }
      .content{
        flex: 1;
        color: var(--g8);
        text-align: right;
        >.a,
        >a,
        >a:active{
          color: var(--c1);
        }

      }
    }
    .fold-btns-line{
      margin-top: calc(var(--gap) * 6);
      padding: calc(var(--gap) * 10) 0;
      display: flex;
      color: var(--g6);
      align-items: center;
      justify-content: center;
      &.show{
        .van-icon-arrow-down{
          transform: rotateZ(180deg);
        }
      }
    }
  }
  .other-infos{
    padding-bottom: 0;
  }
  .operation-nav{
    padding: 0 calc(var(--gap) * 12);
    height: calc(var(--gap) * 52);
    background-color: var(--white);
    // padding: calc(var(--gap) * 16) 0 calc(var(--gap) * 12);
    // margin-top: calc(var(--gap) * 8);
    display: flex;
  
    .btn {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      color: var(--g7);
      >div{
        margin: 0 calc(var(--gap) * 8);
        white-space: nowrap;
        font-size:var(--fs-xs);
        line-height:var(--lh-xs);
      }
      i {
        display: flex;
        height: calc(var(--gap) * 24);
        font-size: calc(var(--w) * 24);
        margin: calc(var(--gap) * 4) 0;
        align-items: center;
        color: var(--g8);
      }
    }
  }
  .add-communicate{
    display: flex;
    align-items: center;
    padding: calc(var(--gap) * 4) calc(var(--gap) * 8);
    border-radius: 16px;
    border: 1px solid #CCCCCC;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
  }
  .del-all-config-content{
    flex: 1;
    max-height: 60vh;
    padding: calc(var(--gap) * 8) calc(var(--gap) * 24) calc(var(--gap) * 26);
    color: var(--g7);
    overflow-y: auto;
    font-size: var(--fs-md);
    line-height: var(--lh-md);
    word-wrap: break-word;
  }
  .zi-tag {
    display: inline-block;
    margin-right: calc(var(--gap) * 6);
    padding: 0 calc(var(--gap) * 4);
    height: calc(var(--w) * 18);
    font-size: var(--fs-sm);
    line-height: var(--lh-sm);
    vertical-align: middle;
    text-align: center;
    border-radius: calc(var(--radius-base)*0.5);
    border: 1px solid var(--g5);
    background-color: var(--c1);
    color: var(--white);
    border-color: var(--c1);
    margin-left: 4px;
  }
}
</style>